export const shareDataElementAction = {
	SET_DATA_ELEMENT : "SET_DATA_ELEMENT",
	SET_RECIPIENT : "SET_RECIPIENT",
	SET_ON_BEHALF_OF : "SET_ON_BEHALF_OF",
	SET_STORE_FOR : "SET_STORE_FOR",
	SET_REFERENCE_ID : "SET_REFERENCE_ID",
	SET_ACTION : "SET_ACTION",
	SET_PAYLOAD : "SET_PAYLOAD",
	SET_ATTACHMENTS : "SET_ATTACHMENTS",
	SET_REQUIRED_ATTACHMENTS : "SET_REQUIRED_ATTACHMENTS",
	SET_STATUS : "SET_STATUS",
	SET_PARTICIPANTS_LIST : "SET_PARTICIPANTS_LIST",
	SET_STORE_FOR_LIST : "SET_STORE_FOR_LIST",
	SET_ON_BEHALF_OF_LIST : "SET_ON_BEHALF_OF_LIST",
	UPDATE_STATE : "UPDATE_STATE",
	RESET : "RESET"
}


const shareDataElementActions = {
	dataElementAction:(value) => {
		return {
			type: shareDataElementAction.SET_DATA_ELEMENT,
			value: value
		}
	},

	recipientAction:(value) => {
		return {
			type: shareDataElementAction.SET_RECIPIENT,
			value: value
		}
	},

	onBehalfOfAction:(value) => {
		return {
			type: shareDataElementAction.SET_ON_BEHALF_OF,
			value: value
		}
	},

	storeForAction:(value) => {
		return {
			type: shareDataElementAction.SET_STORE_FOR,
			value: value
		}
	},

	referenceIdAction:(value) => {
		return {
			type: shareDataElementAction.SET_REFERENCE_ID,
			value: value
		}
	},

	actionAction:(value) => {
		return {
			type: shareDataElementAction.SET_ACTION,
			value: value
		}
	},

	payloadAction:(value) => {
		return {
			type: shareDataElementAction.SET_PAYLOAD,
			value: value
		}
	},

	attachmentsAction:(value) => {
		return {
			type: shareDataElementAction.SET_ATTACHMENTS,
			value: value
		}
	},

	requiredAttachmentsAction:(value) => {
		return {
			type: shareDataElementAction.SET_REQUIRED_ATTACHMENTS,
			value: value
		}
	},

	statusAction:(value) => {
		return {
			type: shareDataElementAction.SET_STATUS,
			value: value
		}
	},

	participantsListAction:(value) => {
		return {
			type: shareDataElementAction.SET_PARTICIPANTS_LIST,
			value: value
		}
	},

	storeForListAction:(value) => {
		return {
			type: shareDataElementAction.SET_STORE_FOR_LIST,
			value: value
		}
	},

	onBehalfOfListAction:(value) => {
		return {
			type: shareDataElementAction.SET_ON_BEHALF_OF_LIST,
			value: value
		}
	},

	updateStateAction:(value) => {
		return {
			type: shareDataElementAction.UPDATE_STATE,
			value: value
		}
	},

	resetAction:() => {
		return {
			type: shareDataElementAction.RESET
		}
	}
}

export default shareDataElementActions
